import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/games';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.18webgame.com' },
    { '@type': 'ListItem', position: 2, name: '游戏分类', item: 'https://www.18webgame.com/category' },
  ],
};

export default function CategoryPage() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = '游戏分类 - 18网页游戏';
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [pathname]);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <Navbar />
      <main className="pt-16">
        <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-900 font-medium whitespace-nowrap">游戏分类</span>
            </nav>
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">游戏分类</h1>
            <p className="text-sm md:text-base text-foreground-600 mb-10">按类型浏览，快速找到你喜欢的网页游戏</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 hover:border-primary-300/40 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-accent-100/70 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200/70 transition-colors duration-300">
                      <i className={`${cat.icon} text-2xl md:text-3xl text-accent-600`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h2 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 mb-1 whitespace-nowrap">
                        {cat.name}
                      </h2>
                      <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                        {cat.description}
                      </p>
                      <span className="text-xs text-foreground-400">
                        <i className="ri-gamepad-line mr-1"></i>
                        {cat.count} 款游戏
                      </span>
                    </div>
                    <div className="flex-shrink-0">
                      <i className="ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 transition-colors duration-200 text-lg"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}